import React from "react"
import { graphql } from "gatsby"
import CaseStudyTemplate from "../../../components/caseStudies/CaseStudyTemplate"
import data from "../../../data/caseStudies/netAtlantic"

const NetAtlantic = ({ data: queryData }) => (
  <CaseStudyTemplate
    {...data}
    heroImage={queryData.heroImage?.childImageSharp?.gatsbyImageData}
  />
)

export default NetAtlantic

export const query = graphql`
  query NetAtlanticCaseStudyImages {
    heroImage: file(relativePath: { eq: "caseStudies/netAtlantic-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
